/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useCallback, useState } from "react"
import type { MediaBatchData } from "../components/admin/mediaPreparationBatchInit/types/mediaBatchCommon.types"
import { MediaBatchPreparationInitServices } from "../service/mediaBatchPrepInitServices";

export const useMediaBatchPrepView = () => {
	const [mediaBatchData, setMediaBatchData] = useState<MediaBatchData | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState(null);

	const fetchBatchDetails = useCallback(async (batchId: number) => {
		try {
			setLoading(true);
			const response = await MediaBatchPreparationInitServices.getViewPreparationDetails({ id: batchId });
			setMediaBatchData(response.data);
		} catch (error: any) {
			setError(error);
			console.error("Error in UseMediaBatch hook. Fetch details failed.")
		} finally {
			setLoading(false);
		}
	}, [])

	return { mediaBatchData, loading, error, fetchBatchDetails }
}
